import { render, staticRenderFns } from "./split.vue?vue&type=template&id=ba8b0bda&scoped=true"
import script from "./split.vue?vue&type=script&lang=js"
export * from "./split.vue?vue&type=script&lang=js"
import style0 from "./split.vue?vue&type=style&index=0&id=ba8b0bda&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8b0bda",
  null
  
)

export default component.exports